/** Marks a control the approved design shows but that has no backend yet (a BACKEND GAP). The control it sits next to is
 * always rendered disabled, and nothing behind it is persisted — it is never a fake. */
export function NotConnected() {
  return <span className="cpr-nyc">Not yet connected</span>;
}
